var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.002 16.3c1.4 0 2.6-1.2 2.6-2.6V3.4c0-1.4-1.2-2.6-2.6-2.6-1.4 0-2.6 1.2-2.6 2.6v10.3c0 1.4 1.2 2.6 2.6 2.6zM24.904 18.4c.4 1.1 1.4 1.8 2.4 1.8.3 0 .5 0 .8-.1 1.4-.4 2.1-1.9 1.7-3.2l-3.3-10.1c-.4-1.4-1.9-2.1-3.2-1.7-1.4.4-2.1 1.9-1.7 3.2l3.3 10.1zM9.202 31.3c.5 0 1.1-.2 1.5-.5 1.1-.8 1.4-2.5.5-3.6l-6.1-8.3c-.8-1.1-2.5-1.4-3.6-.5-1.1.8-1.3 2.4-.5 3.6l6.1 8.3c.5.7 1.3 1 2.1 1zM94.503 18.4c-1.1-.8-2.8-.6-3.6.5l-6.1 8.3c-.8 1.1-.6 2.8.5 3.6.5.3 1 .5 1.5.5.8 0 1.6-.4 2.1-1l6.1-8.3c.8-1.2.6-2.8-.5-3.6zM67.901 20c.3.1.5.1.8.1 1.1 0 2.1-.7 2.4-1.8l3.3-10.1c.4-1.4-.3-2.8-1.7-3.2-1.3-.4-2.8.3-3.2 1.7l-3.3 10.1c-.4 1.3.3 2.8 1.7 3.2z",
    fill: "#3AD08F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.003 22.1c-24.4 0-43.6 23.9-44.4 24.9-.7.9-.7 2.3 0 3.2.8 1 20 24.9 44.4 24.9s43.6-23.9 44.4-24.9c.7-.9.7-2.3 0-3.2-.8-1-20-24.9-44.4-24.9zm0 46.5c-11 0-20-9-20-20s9-20 20-20 20 9 20 20-9 20-20 20zm-39-20c2.9-3.2 10.1-10.6 19.5-15.8-3.5 4.3-5.6 9.8-5.6 15.8s2.1 11.5 5.6 15.8c-9.4-5.2-16.6-12.6-19.5-15.8zm58.5 15.8c3.5-4.3 5.6-9.8 5.6-15.8s-2.1-11.5-5.6-15.8c9.4 5.2 16.6 12.6 19.5 15.8-2.9 3.2-10.1 10.6-19.5 15.8z",
    fill: "#695DE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 37.1c-.4 0-.9.1-1.3.1.8 1 1.3 2.2 1.3 3.6 0 3.2-2.6 5.7-5.7 5.7-2 0-3.7-1-4.8-2.5-.6 1.4-1 2.9-1 4.6 0 6.3 5.1 11.5 11.5 11.5 6.3 0 11.5-5.1 11.5-11.5S54.3 37.1 48 37.1z",
    fill: "#3AD08F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f1cf72cd3b096b39bf5bd08b9c3757a7.svg";
export { ForwardRef as ReactComponent };